import { render } from "./DashboardStudent.vue?vue&type=template&id=f1cfd764"
import script from "./DashboardStudent.vue?vue&type=script&lang=js"
export * from "./DashboardStudent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__